import {Map} from 'immutable'
import {useFormContext, Controller} from 'react-hook-form'
import {useMemo} from 'react'
import PropTypes from 'prop-types'
import {v4 as uuidV4} from 'uuid'

import PermissionSelect from '../../permissions/specific_item/shared_components/PermissionSelect'

import {existingPermissionOptions} from '../../../../../lib/deputyPermissionTools'

import funeralArrangementIcon from '../../../../../shared_assets/100px_icons/funeral-arrangement.svg'

import './manageVaultExtensionPermission.scss'

const ManageVaultExtensionPermission = props => {
  const firstGroupId = props.vaultExtension?.get('id') || uuidV4()
  const {control, watch} = useFormContext()

  const values = watch(firstGroupId)

  const options = useMemo(() => (
    existingPermissionOptions.map(existingPermissionOption => ({...values, ...existingPermissionOption}))
  ), [props.vaultExtension?.get('id')])

  if (props.vaultExtension.isEmpty())
    return null

  return (
    <div className='manage-vault-extension-permission'>
      <div className='prearrangements row-wrapper'>
        <div className='icon-section'>
          <img
            className='funeral-arrangement-icon'
            src={funeralArrangementIcon}
            alt='Funeral arrangement icon'
          />
        </div>
        <div className='text-section'>
          <div className='title'>My Prearrangements</div>
          <div className='funeral-home-name'>
            Provided by {props.vaultExtension.getIn(['firm', 'name'])}
          </div>
        </div>
      </div>
      <Controller
        name={firstGroupId}
        control={control}
        render={({field}) => (
          <PermissionSelect
            {...field}
            classNamePrefix='specific-item-permission-select'
            options={options}
          />
        )}
      />
    </div>
  )
}

ManageVaultExtensionPermission.propTypes = {
  firm: PropTypes.instanceOf(Map),
  vaultExtension: PropTypes.instanceOf(Map)
}

export default ManageVaultExtensionPermission
